import React, { Component } from 'react';
import { URLImgFront } from '../../../config/URLDB';

class Seccion04CooperaGanaMasV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeButton: null
        };
    }

    handleButtonClick = () => {
        if (this.props.mostrarClick) {
            this.props.mostrarClick(true);
        }
        if (this.props.scrollClick) {
            this.props.scrollClick(2);
        }
    };

    scrollToStar = () => {
        const target = document.getElementById("seccion01");
        if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    render() {
        window.scrollTo(0, 0);
        const { activeButton } = this.state;
        return (
            <React.Fragment>
                <section className="planestimulos-contenedor" style={{ backgroundImage: `url(${URLImgFront}/assets/EstrategiasComerciales/FondoNaranja.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }}>
                    <div className="planestimulos-contenedor-img">

                        <div className="planestimulos-img">
                            <div className="planestimulos-sorteo-img">
                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/TextoAlternativasRedencion.svg`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp" width='480px' />
                            </div>
                        </div>

                        <div className="planestimulos-seccion">
                            <div className="planestimulos-sorteo-img">
                                <img src={`${URLImgFront}/assets/EstrategiasComerciales/Premios.png`} data-aos="zoom-out" data-aos-delay="300" alt="InfoPremiosCamp" width='480px' />
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center mb-4">
                        <button className="border-0 bg-transparent" >
                            <img src={`${URLImgFront}/assets/EstrategiasComerciales/AlternativasRedencionNaranja.svg`} alt="Alternativas Redencion Naranja" onClick={() => this.handleButtonClick()} style={{ width: 'auto', height: 'clamp(50px, 6vw, 80px)', touchAction: 'manipulation' }} />
                        </button>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default Seccion04CooperaGanaMasV2;